var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DescriptionSection',[_c('DescriptionItem',{attrs:{"title":"Numery lokomotyw","value":_vm.service.locomotives.map(function (v) { return v.sideNumber; }).join(', ')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }